import React, { useState, useEffect , useRef } from 'react';
import axios from 'axios';
import {
  Grid,
  Button
} from "@mui/material";
import {useReactToPrint} from "react-to-print";
import Topbar from "../global/Topbar";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


function GradeMaster(props) {
  
  const [rooms, setRooms] = useState([]);
  
  const [GradeCode, setGradeCode] = useState('');
  const [Grade, setGrade] = useState('');
  const [GradeHSN, setGradeHSN] = useState('');
  const [GradeRate, setGradeRate] = useState('');
  const [UserID, setUserID] = useState('');
  
  const [errorMessage, setErrorMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [formMode, setFormMode] = useState('add');
  const [editRoomId, setEditRoomId] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [GradeMasterEntries, setGradeMasterEntries] = useState([]);

  const [deleteEntryNo, setDeleteEntryNo] = useState(null);
  const [openConfirmation, setOpenConfirmation] = useState(false);  

  useEffect(() => {
    fetchGradeMaster();
  }, []);


  const fetchGradeMaster = async () =>{
    try{
      const response = await axios.get('https://www.wingap.net.in/api/grade');
      setGradeMasterEntries(response.data);
      const maxEntryNo = calculateMaxEntryNo(response.data);
      const nextEntryNo = maxEntryNo + 1;
      setGradeCode(nextEntryNo)
      //console.log(response)
    }catch(error){
      console.log('error:', error);
    }
  };

  const calculateMaxEntryNo = (entries) => {
    let maxEntryNo = 0;
    for (const entry of entries) {
      if (entry.GradeCode > maxEntryNo) {
        maxEntryNo = entry.GradeCode;
      }
    }
    return maxEntryNo;
  };

  const addGrade = async () => {
    try {
      await axios.post('https://www.wingap.net.in/api/grade', {
        GradeCode: GradeCode,
        Grade: Grade,
        GradeHSN: GradeHSN,
        GradeRate: GradeRate,
        USERID: props.name
      });
      fetchGradeMaster();
      setGradeCode('');
      setGrade('');
      setGradeHSN('');
      setGradeRate('');
      setUserID('');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const updateRoom = async (GradeCode) => {
    try {
      await axios.put(`https://www.wingap.net.in/api/grade/${GradeCode}`, {
        GradeCode: GradeCode,
        Grade: Grade,
        GradeHSN: GradeHSN,
        GradeRate: GradeRate,
        UserID: props.name
      });
      fetchGradeMaster();
      setGradeCode('');
      setGrade('');
      setGradeHSN('');
      setGradeRate('');
      setUserID('');

      setFormMode('add');
    } catch (error) {
      console.log('Error:', error);
    }
  };
  
  const handleDeleteConfirmation = async () => {
    try {
      if (deleteEntryNo) {
        await deleteRoom(deleteEntryNo.GradeCode);
        setOpenConfirmation(false);
      }
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const deleteRoom = async (GradeCode) => {
    try {
      const response = await axios.delete(`https://www.wingap.net.in/api/grade/${GradeCode}`, {
        headers: {
          'username': props.name,
        },
      });

      if (response.status === 200) {
        fetchGradeMaster();
      }
    } catch (error) {
      console.log('Error:', error);

      if (error.response && error.response.status === 403) {
        // User does not have permission to delete account group
        setErrorMessage('Permission Denied');
        setSnackbarOpen(true);
      } else {
        // Handle other errors if needed
        setErrorMessage('An error occurred while deleting the account group. Please try again later.');
        setSnackbarOpen(true);
        // Alternatively, you can log the detailed error to the console for debugging
        console.error('Error:', error);
      }
    }
  };

  const handleCloseSnackbar = () => {
    // Close the Snackbar
    setSnackbarOpen(false);
    // Reset the error message
    setErrorMessage('');
  };  

  const setEditForm = (room) => {
      setFormMode('edit');
      setGradeCode(room.GradeCode);
      setGrade(room.Grade);
      setGradeHSN(room.GradeHSN);
      setGradeRate(room.GradeRate);
      setUserID(room.UserID);

      setShowGrid(false);
  };

 

  const handleshowandhide = () => {
    setShowGrid(!showGrid);
    setRooms(rooms); 
  }

  const handleCancel = () => {
    setFormMode('add');
    setEditRoomId('');
    setGradeCode('');
    setGrade('');
    setGradeHSN('');
    setGradeRate('');
    fetchGradeMaster();
  }

   
  const componentPDF= useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "BookingData",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }
        
        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  return (
    <div style={{ maxWidth: '100%', margin: '0 auto',padding: '20px' }} >
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>Grade Master</h1>
      <Grid item>
          <Button
            variant="contained"
            className="view-button"
            onClick={handleshowandhide}
            sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float:'right'}}
          >
            {showGrid ? 'Add' : 'Back'}
          </Button>
        </Grid>
        {showGrid && <Grid item>
          <Button
            variant="contained"
            onClick={generatePDF}
            sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float:'right', marginRight:"10px"}}
          >
            Download PDF
          </Button>
        </Grid>}
        {showGrid && <Grid item>
          <Button
            variant="contained"
            // onClick={generatePDF}
            sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float:'right', marginRight:"10px"}}
          >
            Export
          </Button>
        </Grid>}
        {!showGrid && (
           <>
           <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>{formMode === 'add' ? 'Add' : 'Edit'}</h2>
           <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="GradeCode" style={{ width: '150px', marginRight: '10px' }}>GradeCode</label>
               <input
                 type="text"
                 value={GradeCode}
                 readOnly
                 placeholder="GradeCode"
                 style={{ marginBottom: '5px', padding: '5px', width: '9%' }}
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="Grade" style={{ width: '150px', marginRight: '10px' }}>Grade</label>
               <input
                 type="text"
                 value={Grade}
                 onChange={(e) => setGrade(e.target.value)}
                 placeholder="Grade"
                 style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
               <label htmlFor="GradeHSN" style={{ width: '150px', marginRight: '10px' }}>GradeHSN</label>
               <input
                 type="text"
                 value={GradeHSN}
                 onChange={(e) => setGradeHSN(e.target.value)}
                 placeholder="GradeHSN"
                 style={{ marginBottom: '5px', padding: '5px', width: '30%' }}
               />
             </div>
             <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
              <label htmlFor="GradeRate" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>GradeRate</label>
              <input
                type="text"
                value={GradeRate}
                onChange={(e) => setGradeRate(e.target.value)}
                placeholder="GradeRate"
                style={{ marginBottom: '5px', padding: '5px', width: '15%' }}
              />
            </div>
            <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
              <label htmlFor="UserID" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>UserID</label>
              <input
                type="text"
                value={UserID}
                readOnly
                onChange={(e) => setUserID(e.target.value)}
                placeholder="UserID"
                style={{ marginBottom: '5px', padding: '5px', width: '15%' }}
              />
            </div>
          </div>
           <div>
             <button
               className={formMode === 'add' ? 'add-button' : 'update-button'}
               onClick={formMode === 'add' ? addGrade : () => updateRoom(GradeCode)}
               style={{
                 padding: '10px 20px',
                 fontSize: '16px',
                 backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
                 color: 'white',
                 border: 'none',
                 cursor: 'pointer',
                 marginBottom: '10px',
               }}
             >
               {formMode === 'add' ? 'Add' : 'Update'}
             </button>
             <button
               className="view-button"
               onClick={handleCancel}
               style={{
                 padding: '10px 20px',
                 fontSize: '16px',
                 backgroundColor: '#f44336',
                 color: 'white',
                 border: 'none',
                 cursor: 'pointer',
                 marginLeft: '10px',
                 marginBottom: '10px',
               }}
             >
               Cancel
             </button>
           </div>
         </>
         
          )}
        {showGrid && (
            <div ref={componentPDF} style={{width:'100%'}}>
              <h2>Entries</h2>
              <table
                style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  border: '1px solid #ccc',
                }}
              >
                <thead>
                  <tr style={{ background: '#f2f2f2', color:'black' }}>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      GradeCode
                    </th>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      Grade
                    </th>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      GradeHSN
                    </th>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      GradeRate
                    </th>
                    <th
                      style={{
                        padding: '8px',
                        background: '#f2f2f2',
                        border: '1px solid #ccc',
                      }}
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {GradeMasterEntries.map((room) => (
                    <tr key={room.DeptCode} style={{backgroundColor:'white', color:'black', textAlign:'center'}}>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.GradeCode}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.Grade}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.GradeHSN}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.GradeRate}</td>

                      <td className="print-hide" >
                        <button
                          style={{
                            padding: '5px 10px',
                            backgroundColor: 'rgb(76, 175, 80)',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                            marginRight: '5px',
                            marginLeft:'10px',
                          }}
                          onClick={() => setEditForm(room)}
                        >
                          Edit
                        </button>
                        <button
                          style={{
                            padding: '5px 10px',
                            backgroundColor: 'rgb(244, 67, 54)',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            setDeleteEntryNo({GradeCode: room.GradeCode});
                            setOpenConfirmation(true); 
                          }}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
      {/* Snackbar for displaying error messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'center', horizontal: 'center' }} // Center the Snackbar
      >
        <MuiAlert elevation={6} variant="filled" severity="error" sx={{ fontSize: '16px' }} onClose={handleCloseSnackbar}>
          {errorMessage}
        </MuiAlert>
      </Snackbar>

      <Dialog
                open={openConfirmation}
                onClose={() => setOpenConfirmation(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Are you sure you want to DELETE ?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setOpenConfirmation(false)} color="inherit">
                    Cancel
                  </Button>
                  <Button onClick={() => handleDeleteConfirmation()} color="error" autoFocus>
                    Confirm
                  </Button>
                </DialogActions>
              </Dialog>
    </div>
  );
}

export default GradeMaster;